// extracted by mini-css-extract-plugin
export var modalFooter = "_u-0";